var map = {
	"./comment.js": "52f8",
	"./commons.js": "dd41",
	"./feedback.js": "55d0",
	"./guestbook.js": "58cc",
	"./job.js": "6b70",
	"./news.js": "bfd9",
	"./topics.js": "ae5b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7bfe";